<template>
  <div class="bank_body">
    <div class="tupian">
      <img :src="tupian">
    </div>

    <van-tabs v-model="activeName">

      <van-tab title="课程列表" name="a">
        <div class="kecheng">
          <van-empty description="暂时没有视频！" v-if="this.list==null || this.list.length==0"/>
          <div class="neirong" v-for="item in list" @click="xiangqing(item)">
            <div :txt="'老师：'+item.teacher"><img :src="item.covermap"></div>
            <div style="height: 60px">
            <div style="line-height: 200%; width: 100%; padding: 0 8px; font-size: 11pt; box-sizing: border-box;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">

              {{item.titles}}
            </div>
            <div class="biaoqian" v-for="itemss in item.tag">
              <div>
                <van-tag type="success">{{itemss}}</van-tag>
              </div>
            </div>
          </div>
          </div>

        </div>
      </van-tab>

      <van-tab title="组合详情" name="b">
        <div class="kechengxiangqing">
          <dl>
            <dt>{{biaoti}}</dt>

            <dd style="color: red"><span>￥</span>{{jine}}
            <dd style="color: #5c5c5c;font-size: 15px"><span>原价￥</span>{{yuanjia}}</dd>
            <dd>{{jieshao}}</dd>
          </dl>
          <!--          <div>-->
          <!--            <van-button type="primary" size="small" @click="goumai">购买</van-button>-->
          <!--          </div>-->
        </div>
        <!--        <div v-html="neirong">{{neirong}}</div>-->
        <div style="width: 100%;height: 9px;background:#f8f8f8; "></div>
        <div class="xiangqing">课程简介</div>
        <!--        <div class="xi">黄梅戏与京剧、越剧、评剧 、豫剧并称“中国五大戏曲剧种”，也是安徽省的主要地方戏曲剧种，湖北、江西、福建、浙江、江苏、香港、-->
        <!--          台湾等地亦有黄梅戏的专业或业余的演出团体，-->
        <!--          受到广泛的欢迎-->
        <!--        </div>-->
        <!--        <div class="xiangqingtu" v-for="item in 5">-->
        <!--          <img src="/6.jpeg">-->
        <!--        </div>-->
        <div class="xi" v-html="neirong">{{neirong}}</div>
      </van-tab>

    </van-tabs>



    <van-goods-action v-if="this.statuse==0">
      <!--      <van-goods-action-icon icon="chat-o" text="客服" @click="onClickIcon" />-->
      <van-goods-action-button type="danger" text="立即购买" @click="onClickButton"/>
    </van-goods-action>


  </div>
</template>

<script>
    import {Toast} from 'vant';


    export default {
        name: "bank",
        data() {
            return {
                activeName: 'a',
                value: ['1'],
                inputt: '',
                tupian: '',
                biaoti: '',
                laoshi: '',
                youxiaoqi: '',
                zhuangtai: '',
                jine: '',
                renshu: '',
                jieshao: '',
                neirong: '',
                listsp: [],
                statuse: '',
                pjlists: [],
                typess: '',
                yp: [],
                yuanjia:'',

              list:"",
            }
        },
        created() {
            this.getdata()
            console.log(222222)
        },
        methods: {
          xiangqing(item) {
            if(this.active!=0){
              this.$router.push({path: '/bank',query: {id: item.id}})
            }else {
              this.$router.push({path: '/group',query: {id: item.id}})
            }

          },
            yinping(item){

                if (item.ivs == 1) {
                    this.$router.push({path: '/yinpin', query: {id: item.id}})
                } else if (this.statuse == 1) {
                    this.$router.push({path: '/yinpin', query: {id: item.id}})
                }
            },
            shiping(item) {
                // if (item.ivs == 1) {
                //     this.$router.push({path: '/bofang', query: {id: item.id}})
                // } else if (this.statuse == 1) {
                //     this.$router.push({path: '/bofang', query: {id: item.id}})
                // }
            },
            goumai() {
                this.$router.push({path: '/Place'})
            },
            onClickIcon() {
                this.myrequest({
                    url: '/client/addcollection.action',
                    types: 'post',
                    data: {
                        // token:this.$store.state.token
                        cid: this.$route.query.id
                    },
                    succ: (res) => {
                        Toast.success('收藏成功');
                        this.$router.go(-1)
                    },
                    errs: (msg) => {

                    }
                })
            },
            onClickButton(item) {
                this.$router.push({path: '/purchases', query: {id: this.$route.query.id}})
            },

            getdata() {
                this.myrequest({
                    url: '/client/getpackageinfo.action',

                    types: 'get',
                    data: {
                        // token:this.$store.state.token
                        id: this.$route.query.id
                    },
                    succ: (res) => {
                      console.log(res)
                      this.list=res.currlist
                      this.tupian=res.info.coverimg
                      this.biaoti=res.info.titles
                      this.jine=res.info.fee
                      this.yuanjia=res.info.price
                      this.neirong=res.info.contents
                      this.statuse=res.orderstatus
                      console.log(res.orderstatus)
                      console.log(this.statuse)


                        /*this.tupian = res.data.covermap
                        this.biaoti = res.data.titles
                        this.laoshi = res.data.teacher
                        this.youxiaoqi = res.data.effectivetime
                        this.zhuangtai = res.data.types
                        this.jine = res.data.fee
                        this.renshu = res.data.buynum
                        this.jieshao = res.data.introduce
                        this.neirong = res.data.content
                        this.listsp = res.splist
                        this.pjlists = res.pjlisr
                        this.statuse = res.orderstatus
                        this.yp = res.yplist
                        this.yuanjia=res.data.price*/
                    },
                    errs: (msg) => {

                    }
                })
            }
        },

    }
</script>

<style scoped lang="stylus">
.kecheng {
  width 100%;
  margin 10px auto;
}
.neirong {
  overflow hidden
  border-radius 5px;
  width calc(50% - (10px * 3) / 2);
  background-color #fafafa;
  height auto;
  float left;
  /*text-align center*/
  margin-left 10px;
  margin-bottom 15px;
  /*margin-right 10px;*/
  box-shadow: 0px 0px 6px rgba(0, 0, 0, .15);

  > div:first-child {
    position relative
  }

  > div:first-child::before {
    background rgba(0, 0, 0, .5)
    width 100%;
    height 100%;
    position absolute
    top 0
    left 0
    content ""
    text-align right
  }

  > div:first-child::after {
    content attr(txt)
    position absolute
    bottom 10px
    right 10px
    color #fff
  }

  img {
    width 100%;
    /*border-radius 10px;*/
    /*box-shadow: 5px 5px 5px rgba(0,0,0,.5);*/
  }

  div {
    color #333333
  }

  >div:nth-of-type(2){
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

.biaoqian {
  div {
    float left;
    margin-left 10px;
    margin-top 5px;
    padding-bottom 10px;
  }
}

.kecheng {
  width 100%;
  margin 10px auto;
}
  .bank_body {
    width 100%;
    position relative;

    .kechengxiangqing {
      width 95%;
      margin 10px auto;

      dl {
        width 100%

        dt {
          font-size 12pt
          font-weight 500
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        dd {
          margin-left 0
        }

        dd:nth-of-type(1) {
          font-size 9pt
          color #666
          line-height 200%
        }

        dd:nth-of-type(2) {
          font-size 13pt
          color #e9353e

          span {
            font-size 9pt
          }
        }
        dd:nth-of-type(3) {
          font-size 9pt
          color #666
          line-height 200%
        }

        dd:nth-of-type(3) {
          margin-top 5px
          color #888
          font-size 10pt
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
      }

      .biaoti {
        font-weight 500;
        font-size 16px;
        color #333333;
        margin-left 10px;
      }

      .laoshi {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 10px;
      }

      .cputong {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }

      .xianshi {
        /*margin-left 5px;*/

        .xianshiname {
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }

        .youxiao {
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }

        .xianjia {
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }

        .suzhi {
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }

        .jieshi {
          font-weight 500;
          font-size 14px;
          color #ccc;
          margin-left 5px;
          margin-top 5px;
        }
      }
    }

    .foot {
      width 95%;
      margin auto;
      display flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position fixed;
      bottom 0px;

      .shuru {
        width 85%;
      }

      .anniu {
        width 10%;
      }
    }

    .tupian {
      width 100%;
      max-height 100vw
      overflow hidden

      img {
        width 100%;
        /*height 250px;*/
      }
    }

    .xiangqing {
      font-weight 500;
      font-size 16px;
      color #333333;
      width 90%;
      margin 10px auto;
    }

    .xi {
      width 90%;
      margin 10px auto;
      line-height 1.5
    }

    .xiangqingtu {
      width 90%;
      margin 0px auto;

      img {
        width 100%;
        display block
      }
    }

    .shiping {
      position relative;
      margin-top 10px;

      >>> .van-collapse-item__content {
        padding 0px;
      }
      width 90%;
      margin 10px auto;
      display flex;

      .xiabiao {
        margin-right 10px;
      }

      .kecheng {

      }

      .bofang {
        position absolute;
        right 0px;

        img {
          width 20px;
          height 20px;
        }
      }
    }

    .pinglun {
      width 90%;
      margin 10px auto;
      display flex

      .touxiang {
        margin-top 10px;

        img {
          width 40px;
          height 40px;
          border-radius 30px;
        }
      }

      .neirong {
        margin-left 10px;

        .name {
          color #333333;
          font-size 14px;
          line-height 30px
          font-weight 500
        }

        .ping {
          margin-top 0px;
          color #444;
        }

        .shijian {
          /*margin-top 5px;*/
          color #ccc;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ziyuanku/group.vue